import * as React from 'react'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as IconFacebook } from '../../../assets/svg/icon-facebook.svg'
import { ReactComponent as IconInstagram } from '../../../assets/svg/icon-instagram.svg'
import { ReactComponent as IconHeartFavorite } from '../../../assets/svg/icon-heart-favorite.svg'
import { ReactComponent as IconMenuSearch } from '../../../assets/svg/icon-menu-search.svg'

export default function BrandSettings(props) {
    return (
        <div className="mastcontent mb-[100px]">
            <div className="container mx-auto">
                <div className="mt:8 lg:mt-16">
                    <h2 className="font-[CircularStd] text-text-1 mb-6 text-5xl mr-1 uppercase">Settings</h2>

                    <div className="flex flex-row justify-between items-start">
                        <div className="basis-5/7 bg-surface rounded-xl py-4">
                            <h3 className="text-error mb-5 font-bold text-center my-2"> Missing functionality </h3>
                            Payments
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
